<script setup lang="ts">
import MItemLabel from "../../../../components/medicus/MItemLabel";
import { isString } from "vue-composable";
import MAvatar from "../../../../components/medicus/MAvatar";
import MItem from "../../../../components/medicus/MItem";
import MSeparator from "../../../../components/medicus/MSeparator";
import { MenuGroup, MenuItem } from "../_types";

defineProps<{
  item: MenuItem | MenuGroup;
}>();
</script>
<template>
  <m-item
    class="sidebar-menu-item"
    v-bind="item"
    :to="item.to && isString(item.to) ? `/${$route.params.tenant}${item.to}` : item.to"
  >
    <m-item-label
      :class="[!item.to && !item.to && !item.toSlideover && !item.toModal && 'caption']"
    >
      <m-item-section>
        <m-avatar v-if="item.avatar" :name="item.avatar" workspace />
        <span
          :class="{ 'sidebar-menu-item--caption': !item.to && !item.toSlideover && !item.toModal }"
        >
          {{ item.label }}
        </span>
      </m-item-section>
    </m-item-label>
  </m-item>
  <template v-if="'items' in item">
    <m-separator />
    <SidebarMenuItem
      v-for="child in item.items"
      :key="`sidebar-menu-item-${item.label}--${child.label}`"
      :item="child"
    />
  </template>
</template>
<style lang="scss">
.sidebar-menu-item {
  .q-item__section,
  .m-item-section {
    flex-wrap: nowrap;
    flex-direction: row;

    gap: 5px;

    .m-avatar {
      flex: 0 0 auto;
    }

    span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
